import { useNavigate } from "react-router-dom";

import { PickYourJourney } from "modules/personalisation/components/PickYourJourney";
import { usePersonalisationData } from "modules/personalisation/context/PersonalisationDataContext";
import { usePersonalisationLeave } from "modules/personalisation/context/PersonalisationLeaveContext";

import { HeritageContainer_PATH } from "./HeritageContainer";
import { ImproveConcernsContainer_PATH } from "./ImproveConcernsContainer";
import { JourneyDetailsContainer_PATH } from "./JourneyDetailsContainer";
import { YouAreNotAloneContainer_PATH } from "./YouAreNotAloneContainer";

export const PickYourJourneyContainer_PATH =
  "/personalise/pick-your-journey" as const;

export function PickYourJourneyContainer() {
  const navigate = useNavigate();
  const { journey, setJourneyAnswered, skipJourney } = usePersonalisationData();
  const { openConfirmLeave } = usePersonalisationLeave();
  return (
    <PickYourJourney
      progressPercentage={15}
      initialSelectedId={journey.state === "answered" ? journey.value : null}
      onContinue={(selection) => {
        setJourneyAnswered(selection);
        if (selection === "intermediate" || selection === "advanced") {
          navigate(JourneyDetailsContainer_PATH);
        } else {
          navigate(YouAreNotAloneContainer_PATH);
        }
      }}
      onSkip={() => {
        skipJourney();
        navigate(HeritageContainer_PATH);
      }}
      onBack={() => navigate(ImproveConcernsContainer_PATH)}
      onClose={openConfirmLeave}
    />
  );
}
